import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import Label from '../vera-score/vera-label';
import { quartileColorScale } from '../../styles/graphs';
import { PhotoCoin } from '../coins';
import { EntityScorePopoverProps } from '../../types/tooltips';
import { scoreToQuartileScale } from '../../components/graphs/utils';

class EntityScorePopover extends React.Component<EntityScorePopoverProps, any> {
  public static defaultProps: EntityScorePopoverProps = {
    score: 0,
    entityType: 'driver',
  };

  public render() {
    const { avatarUrl, className, driverName, score, entityType } = this.props;
    const quartileColor = quartileColorScale(scoreToQuartileScale(score));

    return (
      <div className={className}>
        <PhotoCoin
          src={avatarUrl}
          entityType={entityType}
          className="entity-photo"
          size="lg"
        />
        <span className="entity-name">{driverName}</span>
        <Label style={{ backgroundColor: quartileColor }}>{score}</Label>
      </div>
    );
  }
}

export default styled(EntityScorePopover)`
  min-width: 120px;
  padding: 1em;
  text-align: center;

  .entity-photo {
    margin: 0 auto 0.75em;
  }

  .entity-name {
    display: block;
    margin: 0 auto 0.5em;
  }
`;
